import { render, staticRenderFns } from "./DeductionsChange.vue?vue&type=template&id=47b36da6&scoped=true&"
import script from "./DeductionsChange.vue?vue&type=script&lang=js&"
export * from "./DeductionsChange.vue?vue&type=script&lang=js&"
import style0 from "./DeductionsChange.vue?vue&type=style&index=0&id=47b36da6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b36da6",
  null
  
)

export default component.exports